import { render, staticRenderFns } from "./parcel_create.vue?vue&type=template&id=2130fb6e&scoped=true&"
import script from "./parcel_create.vue?vue&type=script&lang=js&"
export * from "./parcel_create.vue?vue&type=script&lang=js&"
import style0 from "./parcel_create.vue?vue&type=style&index=0&id=2130fb6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130fb6e",
  null
  
)

export default component.exports